import CatalogFiltersParameterMixin from '~/mixins/CatalogFiltersParameterMixin'

export default {
  mixins: [CatalogFiltersParameterMixin],
}
